<template>
    <div class="tool-request-message">
        <div class="tool-header">
            <span class="tool-icon">🔧</span>
            <span class="tool-title">正在调用工具</span>
        </div>
        <div class="tool-content">
            <div v-for="(tool, index) in toolCalls" :key="index" class="tool-item">
                <div class="tool-item-header">
                    <span class="tool-name">{{ tool.name }}</span>
                    <span v-if="tool.id" class="tool-id">{{ tool.id }}</span>
                </div>
                <div class="tool-args-wrapper">
                    <div class="args-label">参数:</div>
                    <div v-if="parsedArgs[index]" class="tool-args">
                        <pre>{{ JSON.stringify(parsedArgs[index], null, 2) }}</pre>
                    </div>
                    <div v-else-if="tool.arguments" class="tool-args">
                        <pre>{{ tool.arguments }}</pre>
                    </div>
                    <div v-else class="tool-args empty">无参数</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    toolCalls: {
        type: Array,
        default: () => []
    }
})

const parsedArgs = computed(() => {
    if (!props.toolCalls || props.toolCalls.length === 0) return []
    return props.toolCalls.map(tool => {
        if (!tool.arguments) return null
        try {
            return JSON.parse(tool.arguments)
        } catch {
            return null
        }
    })
})
</script>

<style lang="scss" scoped>
.tool-request-message {
    background: linear-gradient(135deg, #E6F7FF, #F0F9FF);
    border: 1px solid #91D5FF;
    border-radius: 12px;
    padding: 12px;
    margin: 4px 0;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
}

.tool-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    color: #1890FF;
}

.tool-icon {
    font-size: 16px;
}

.tool-title {
    font-weight: 600;
    font-size: 13px;
}

.tool-content {
    background: white;
    border-radius: 8px;
    overflow: hidden;
}

.tool-item {
    padding: 10px;
    border-bottom: 1px solid #E8F0FE;

    &:last-child {
        border-bottom: none;
    }
}

.tool-item-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.tool-name {
    font-weight: 600;
    color: #333;
    font-size: 13px;
    font-family: 'Monaco', 'Menlo', monospace;
}

.tool-id {
    font-size: 10px;
    color: #999;
    font-family: 'Monaco', 'Menlo', monospace;
    background: #f5f5f5;
    padding: 2px 6px;
    border-radius: 3px;
}

.tool-args-wrapper {
    .args-label {
        font-size: 11px;
        color: #666;
        margin-bottom: 4px;
        font-weight: 500;
    }
}

.tool-args {
    background: #f8f8f8;
    border-radius: 6px;
    padding: 8px;
    margin-top: 4px;

    &.empty {
        color: #999;
        font-style: italic;
        background: #fafafa;
    }

    pre {
        margin: 0;
        font-size: 12px;
        color: #333;
        font-family: 'Monaco', 'Menlo', monospace;
        white-space: pre-wrap;
        word-break: break-all;
    }
}
</style>
